import { Component } from '@angular/core';

@Component({
    selector: 'itfg-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
    standalone: false
})
export class ProgressSpinnerComponent {

}
